// extracted by mini-css-extract-plugin
module.exports = {"grid":"GridItem_grid__eovun"};